export const SlideadjustmentunitpriceCode = {
    /** （電気共通）再エネ賦課金単価 */
    reEnergyTanka: "AT7",
} as const;